import { EditorState, convertFromRaw } from "draft-js";
import { EditorProps } from "react-draft-wysiwyg";
import dynamic from "next/dynamic";

const Editor = dynamic<EditorProps>(
    () => import("react-draft-wysiwyg").then((mod) => mod.Editor),
    { ssr: false }
);

export default function Content({ content }: { content: string }) {
    const contentState = convertFromRaw(JSON.parse(content));

    const editorState = EditorState.createWithContent(contentState);

    return (
        <section className="relative">
            <div className="mx-auto px-6 lg:px-0 mb-8 leading-loose">
                <div className="editor-body">
                    <Editor
                        editorState={editorState}
                        readOnly={true}
                        toolbarHidden={true}
                        onChange={null}
                    />
                </div>
            </div>
        </section>
    );
}
